import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import { FC, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PrimaryButton from "components/PrimaryButton";
import { StyledContainer } from "components/StyledContainer";
import Transition from "components/Transition";
import {
  ChecklistType,
  Maybe,
} from "operations/schema/schema";
import { useAppDispatch, useAppSelector } from "store";
import { selectPageSelectedJob } from "store/root.store";
import { updateChecklist } from "store/slices/jobs.store";
import { ChecklistRenderer } from "pages/jobs/jobDetails/visit/ChecklistRenderer";

type ChecklistDialogProps = {
  open: boolean;
  handleClose: () => void;
  index: number;
  checklist: ChecklistType | null | Maybe<ChecklistType>;
  readonly?: boolean;
};

export const ChecklistDialog: FC<ChecklistDialogProps> = (props) => {
  const { open, handleClose, index, checklist } = props;
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const { externalId } = useAppSelector(selectPageSelectedJob);
  const [checklistState, setChecklistState] = useState<ChecklistType | null>(null);

  useEffect(() => {
    if (checklist) {
      setChecklistState(cloneDeep(checklist));
    }
  }, [checklist]);

  const save = () => {
    if (checklistState) dispatch(updateChecklist({ checklist: checklistState, index }));
    handleClose();
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      data-testid="ChecklistDialog"
    >
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label={intl.formatMessage({ id: "general.back" })}
            size="large"
            data-testid="ChecklistDialogCloseButton"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography className="AppBar-label" paddingRight="36px">
            {externalId} / {checklistState?.title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      {checklistState && (
        <StyledContainer>
          <ChecklistRenderer
            checklist={checklistState}
            setChecklist={setChecklistState}
            onSave={save}
            renderSaveButton={
              <PrimaryButton
                fullWidth
                onClick={save}
                className="e2e-save-checklist-button"
                data-testid="ChecklistDialogSaveButton"
              >
                <FormattedMessage id="general.save" />
              </PrimaryButton>
            }
          />
        </StyledContainer>
      )}
    </Dialog>
  );
};